var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcDoNotDisturbAlt = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "herenga",
    x: 0,
    y: 0,
    width: 1280,
    height: 1484
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.4%",
    y: "-0.3%",
    width: "100.8%",
    height: "100.7%",
    filterUnits: "objectBoundingBox",
    id: "herenga4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "herenga2",
    x: 0,
    y: 0,
    width: 1220,
    height: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,1.5 C4.875,1.5 1.5,4.875 1.5,9 C1.5,13.125 4.875,16.5 9,16.5 C13.125,16.5 16.5,13.125 16.5,9 C16.5,4.875 13.125,1.5 9,1.5 L9,1.5 Z M3,9 C3,5.7 5.7,3 9,3 C10.35,3 11.625,3.45 12.675,4.275 L4.275,12.675 C3.45,11.625 3,10.35 3,9 L3,9 Z M9,15 C7.65,15 6.375,14.55 5.325,13.725 L13.725,5.325 C14.55,6.375 15,7.65 15,9 C15,12.3 12.3,15 9,15 L9,15 Z",
    id: "herenga3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "herenga15",
    x: 0,
    y: 0,
    width: 37.5,
    height: 37.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "herenga5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "herenga6",
    transform: "translate(-1218.000000, -578.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1703
  }), /*#__PURE__*/React.createElement("rect", {
    id: "herenga9",
    stroke: "#DFE2E5",
    fill: "#F7F8FA",
    x: -0.5,
    y: 123.5,
    width: 1441,
    height: 1580
  }), /*#__PURE__*/React.createElement("g", {
    id: "herenga7",
    transform: "translate(80.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "herenga8"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#herenga4)",
    xlinkHref: "#herenga"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#herenga"
  })), /*#__PURE__*/React.createElement("g", {
    id: "herenga10",
    transform: "translate(30.000000, 384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "herenga11",
    transform: "translate(0.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "herenga12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#herenga2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "herenga16",
    fill: "#FFFFFF",
    xlinkHref: "#herenga2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "herenga17-10",
    mask: "url(#herenga12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(369.000000, 12.000000)",
    id: "herenga17-29"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(738.000000, 0.000000)",
    id: "herenga20"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "herenga18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#herenga3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "herenga16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "herenga17",
    mask: "url(#herenga18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.750000, -9.750000)",
    id: "herenga14"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "herenga13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#herenga15"
  })), /*#__PURE__*/React.createElement("use", {
    id: "herenga19",
    fill: "#901111",
    xlinkHref: "#herenga15"
  })))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcDoNotDisturbAlt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-do-not-disturb-alt.68e40126.svg";
export { ForwardRef as ReactComponent };